import i18n from '@/libs/i18n'

export default [
  {
    path: '/campaign',
    name: 'campaign',
    component: () => import('@/views/campaign/Campaign.vue'),
    meta: {
      pageTitle: i18n.t('campaign.textPageTitle'),
      requireAuth: true,
      requireUpdateInfo: true,
      hasGrayBg: true,
    },
  },
  {
    path: '/campaign/duplicate',
    name: 'duplicate-campaign',
    component: () => import('@/views/campaign/components/duplicate/CampaignSetupView.vue'),
    meta: {
      pageTitle: i18n.t('campaign.textPageTitle'),
      layout: 'vertical',
      requireAuth: true,
      hasGrayBg: true,
      requireUpdateInfo: true,
    },
  },
]
